module.exports = __webpack_public_path__ + "static/assets/c758ea533da24f3d8cbb8c50bbc292e2.png";